export enum ClinicDetailsTabType {
  CLINIC_INFO = 'clinic-info',
  AUDIT_ACTIVITY = 'audit-activity',
}
